import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class AuthTokenlessBaseService {
    constructor(public http: HttpClient) {}

    PAGE_SIZE = 25;

    apiUrl(endpoint: string): string {
        const host: string = (window as any)['__env'].apiEndpoint;
        const url = `${host}/${endpoint}`;
        return url;
    }
}
